import React from 'react';
import SavingsIcon from '@mui/icons-material/Savings';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import './ProductDetail.css';
import Grid from '@mui/material/Grid';
import { useStateValue } from '../Store/StateProvider';
import { Rating } from '@mui/material';
import CurrencyFormat from 'react-currency-format';
import replacement from '../Assets/images/replacement.png';
import fastdelivery from '../Assets/images/fast-delivery.png';
import nocontact from '../Assets/images/nocontact.png';
import warranty from '../Assets/images/warranty.png';
function ProductDetail() {
    const [{ basket, user, product_d }, dispatch] = useStateValue();

    const addToBasket = () => {
        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                id: product_d.id,
                title: product_d.title,
                image: product_d.image,
                price: product_d.price,
                rating: product_d.rating
            }
        })
    };
    console.log(product_d)
    return (
        <div className="product__detail">
            <Grid container>
                <Grid item md={6} sm={12} className='detailProduct_imageBox'>
                    <img className="productDetail_image" src={product_d.image} />
                </Grid>
                <Grid item md={6} sm={12} style={{ width: "100%" }} >
                    <p className="productDetail__title">{product_d.title}</p>
                    <p className="productDetail__category">Catergory: <strong>{product_d.category}</strong></p>
                    <div className="productDetail__rating">
                        <Rating
                            value={product_d.rating}
                            precision={0.1}
                        />
                    </div>
                    <CurrencyFormat
                        renderText={(value) => (
                            <>
                                <p className="productDetail__price">
                                    Price: <strong> {value} </strong>
                                </p>
                            </>
                        )}
                        decimalScale={2}
                        value={product_d.price}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={"₹"}
                    />
                    <div className='productDetail__offers'>
                        <table>
                            <tr>
                                <span> <SavingsIcon /> <td> <strong> Save Extra</strong> with 5 offers</td></span>
                            </tr>
                            <tr>
                                <span> <AccountBalanceIcon /> <td><strong>No Cost EMI:</strong> Avail No Cost EMI on select cards for orders above ₹3000</td></span>
                            </tr>
                            <tr>
                                <span >
                                    <PublishedWithChangesIcon /> <td><strong>Exchange Offer:</strong> Exchange is available.</td>
                                </span>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <div className='productDetail__features'>
                        <div className="productDetails__features__item">
                            <div className="productDetail__feature__icon"><img src={replacement} alt="" /></div>
                            <div className="productDetail__feature__title">7 Days Replacement</div>
                        </div>
                        <div className="productDetails__features__item">
                            <div className="productDetail__feature__icon"><img src={fastdelivery} alt="" /></div>
                            <div className="productDetail__feature__title">Superfast Delivery</div>
                        </div>
                        <div className="productDetails__features__item">
                            <div className="productDetail__feature__icon"><img src={warranty} alt="" /></div>
                            <div className="productDetail__feature__title">1 Year Warranty</div>
                        </div>
                        <div className="productDetails__features__item">
                            <div className="productDetail__feature__icon"><img src={nocontact} alt="" /></div>
                            <div className="productDetail__feature__title">No-Contact Delivery</div>
                        </div>
                    </div>
                    <br />
                    <button className='productDetail__button' onClick={addToBasket}>Add to Cart</button>
                    <div className='productDetail_description'>
                        <h3>Product Description:</h3>
                        <div className='productDetail_descriptionText'> {product_d.description}</div>
                    </div>
                </Grid>

            </Grid>
        </div >
    )
}

export default ProductDetail;
